import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppTokenHandler } from '../../common/app-token-handler';
import { environment } from '../../../environments/environment';

enum Roles {
    Admin = 1,
    User = 2,
    EP = 3,
    EM = 4,
    Delegate = 5
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    menuitems: MenuItem[];
    useritems: MenuItem[];
    subitems: Array<{ label: string, icon: string, routerLink: string }> = [];
    CartObject: Array<any> = [];
    cartText: string = "";
    constructor(private router: Router, private appToken: AppTokenHandler) {
    }
    ngOnInit() {
        this.BindMenuItems();
        if (sessionStorage.getItem('ResumeCart') != null) {
            this.CartObject = JSON.parse(sessionStorage.getItem('ResumeCart'));
        }
        this.cartText = "Resume Cart (" + this.CartObject.length + ")";
    }

    CreateResume() {
        this.appToken.setRequestType('');
        this.router.navigate(['/home/create-resume']);
    }
    CreateMyResume() {
        this.appToken.setRequestType('');
        this.router.navigate(['/home/my-resume']);
    }
    CreateNewResume() {
        this.appToken.setRequestType('');
        this.router.navigate(['/home/resume']);
    }
    CreateNewDelegate() {
        this.appToken.setRequestType('');
        this.router.navigate(['/home/add-delegate']);
    }
    ViewDelegate() {
        this.appToken.setRequestType('');
        this.router.navigate(['/home/view-delegate']);
    }
    SearchResume() {
        this.router.navigate(['/home/SearchResume']);
    }
    RedirectToResumeCart() {
        this.router.navigate(['/home/ResumeCart']);
    }
    BindMenuItems() {
        this.menuitems = [
            {
                label: 'Home', routerLink: '/home/dashboard'
            }
            , {
                label: 'Update Information',
                items: [
                    { label: 'Update for Self', command: () => this.CreateNewResume() },
                    { label: 'Update for Others', command: () => this.CreateResume(), visible: (this.appToken.IsInRole("Delegate")) },
                    { label: 'View Resume', command: () => this.CreateMyResume() }
                ]
            }
            , {
                label: 'Delegation',
                items: [
                    { label: 'Add Delegate', command: () => this.CreateNewDelegate() },
                    { label: 'View Delegate', command: () => this.ViewDelegate() }
                ]
                //,visible: (this.appToken.IsInRole("EP,EM"))
            }
            , {
                label: 'Search Personnel', command: () => this.SearchResume()
            }
        ];

        if (!environment.production) {
            this.subitems.push({ label: 'Run as different user', icon: 'fa fa-unlock', routerLink: '/dummylogin' });
        }
        this.subitems.push({ label: 'Logout', icon: 'fa fa-sign-out', routerLink: '/logout' });
        this.useritems = [
            {
                label: this.appToken.getLoginUserInfo().EmpName, icon: 'fa fa-user',
                items: this.subitems
            },
        ];

    };
}
